/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ api: NonNullable<unknown> }} Audit_Details_Api_Template_Added_DescInputs */



/**
* | output |
* | --- |
* | "The external API \"{api}\" was approved." |
*
* @param {Audit_Details_Api_Template_Added_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_api_template_added_desc = /** @type {((inputs: Audit_Details_Api_Template_Added_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Api_Template_Added_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die externe API "${i?.api}" wurde freigegeben.`)
	return /** @type {LocalizedString} */ (`The external API "${i?.api}" was approved.`)
});